var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocciergeShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.133 38.6174C15.7718 40.4264 15.5904 42.2667 15.5913 44.1114V44.6839H23.7264C25.1243 44.6822 26.4645 44.1261 27.453 43.1376C28.4415 42.1491 28.9976 40.8089 28.9993 39.4109V29.0508C22.9529 29.1526 17.9058 33.1392 16.133 38.6174Z",
    fill: "url(#paint0_linear_6753_207083)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4448 23.7557L23.7288 24.4777C19.805 28.3971 17.2019 33.2817 16.1343 38.5959C16.2968 38.103 19.265 29.3575 28.9974 29.0498V20.0654C27.3553 21.1334 25.8295 22.3702 24.4448 23.7557Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0826 15.6433C38.6482 15.6433 33.4522 17.1951 28.9971 20.0892V29.0508H39.3821C40.7799 29.0495 42.12 28.4939 43.1085 27.5057C44.097 26.5176 44.6533 25.1777 44.6551 23.78V15.6433H44.0826Z",
    fill: "url(#paint1_linear_6753_207083)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5223 6.06666C28.8835 4.25766 29.0649 2.41738 29.064 0.572686L29.064 0.000164032L20.9289 0.000163321C19.531 0.00188267 18.1908 0.557979 17.2022 1.54648C16.2137 2.53498 15.6576 3.87518 15.6559 5.27314L15.6559 15.6333C21.7024 15.5315 26.7495 11.5449 28.5223 6.06666Z",
    fill: "url(#paint2_linear_6753_207083)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2104 20.9284L20.9265 20.2064C24.8502 16.287 27.4534 11.4024 28.521 6.08822C28.3585 6.58113 25.3903 15.3266 15.6579 15.6343L15.6579 24.6187C17.2999 23.5507 18.8258 22.3139 20.2104 20.9284Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.572674 29.0408C6.00706 29.0408 11.2031 27.4889 15.6582 24.5949L15.6582 15.6333L5.27313 15.6333C3.87542 15.6346 2.53529 16.1902 1.54676 17.1784C0.558228 18.1665 0.00201595 19.5064 0.000152346 20.9041L0.000151634 29.0408L0.572674 29.0408Z",
    fill: "url(#paint3_linear_6753_207083)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6753_207083",
    x1: 15.5913,
    y1: 36.867,
    x2: 28.9993,
    y2: 36.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.31
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6753_207083",
    x1: 31.1877,
    y1: 23.5683,
    x2: 46.6101,
    y2: 21.6657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.96
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6753_207083",
    x1: 22.8593,
    y1: 14.3536,
    x2: 24.7591,
    y2: -2.68258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.96
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6753_207083",
    x1: 15.6582,
    y1: 22.3373,
    x2: 0.00015222,
    y2: 22.3373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.31
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocciergeShape);
export default __webpack_public_path__ + "static/media/doccierge-shape.bc0aa891c9754725eafa2fa6ce9eb89a.svg";
export { ForwardRef as ReactComponent };